import { CommonModule } from '@angular/common';
import { Component, forwardRef, model } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { NameTag } from './name-tag.component';

@Component({
    selector: 'app-input-chip',
    templateUrl: './input-chip.component.html',
    imports: [CommonModule, NameTag],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => InputChip),
            multi: true,
        },
    ],
})
export class InputChip implements ControlValueAccessor {
    value = model<string[]>([]);

    inputValue = model('');

    writeValue(obj: any): void {
        if (Array.isArray(obj)) {
            this.value.set(obj);
        } else {
            this.value.set([]);
        }
    }
    registerOnChange(fn: any): void {}
    registerOnTouched(fn: any): void {}
    setDisabledState?(isDisabled: boolean): void {}
    onChange: (value: any) => void = () => {};
    onTouched: () => void = () => {};

    handleKeyDown(event: KeyboardEvent): void {
        event?.stopPropagation();
        event?.preventDefault();
        if (event.key === 'Enter' || event.key === ',') {
            const inputValue = this.inputValue().trim();

            if (inputValue) {
                const values = this.value() || [];
                if (!values.includes(inputValue)) {
                    values.push(inputValue);
                    this.value.set(values);
                }
                this.inputValue.set('');
            }
        }
    }

    removeChip(index: number): void {
        this.value.set(this.value().filter((v) => v !== ''));
    }
}
